<template>
  <b-modal
      id="modal-detail"
      :title="file ? file.title || file.originalName : 'جزئیات فایل'"
      size="lg"
      hide-footer
      header-bg-variant="light"
      @shown="onModalShown"
      @hidden="destroyHlsPlayer"
  >
    <div v-if="file">
      <!-- Media Display Section -->
      <div class="media-display mb-3" style="position: relative;">
        <!-- Video with HLS -->
        <div v-if="isVideo && isHlsAvailable" class="hls-player-wrapper">
          <video ref="hlsMedia" controls playsinline class="w-100"></video>
<!--          <div v-if="variantQualities.length > 1" class="quality-control">-->
<!--            <span>کیفیت: </span>-->
<!--            <b-form-select-->
<!--                v-model="selectedVariantQuality"-->
<!--                :options="variantQualityOptions"-->
<!--                size="sm"-->
<!--                @change="changeVariantQuality"-->
<!--            />-->
<!--          </div>-->
        </div>

        <!-- Audio with HLS -->
        <div v-else-if="isAudio && isHlsAvailable" class="hls-player-wrapper audio-player">
          <audio ref="hlsMedia" controls class="w-100"></audio>
        </div>

        <!-- Video without HLS -->
        <div v-else-if="isVideo && !isHlsAvailable" class="fallback-video-wrapper">
          <video controls :src="fullFileUrl" class="w-100" style="max-height:400px;background:#000;"></video>
          <b-alert variant="warning" show class="mt-2">
            این ویدیو به صورت HLS در دسترس نیست. نسخه اصلی در حال پخش است.
            <b-button variant="primary" size="sm" class="ml-auto" @click="$emit('hls')">
              تبدیل به HLS
            </b-button>
          </b-alert>
        </div>

        <!-- Audio without HLS -->
        <div v-else-if="isAudio && !isHlsAvailable" class="audio-display">
          <div class="text-center mb-2">
            <p class="mt-2 font-weight-bold">{{ file.title || file.originalName }}</p>
          </div>
          <audio controls :src="fullFileUrl" class="w-100" style="border-radius: 8px;"></audio>
          <b-alert variant="info" show class="mt-2">
            <i class="fas fa-info-circle"></i>
            برای پخش با کیفیت بهتر، این فایل را به HLS تبدیل کنید.
            <b-button variant="primary" size="sm" class="ml-auto" @click="$emit('hls')">
              تبدیل به HLS
            </b-button>
          </b-alert>
        </div>

        <!-- Document -->
        <div v-else-if="isDocument" class="document-display text-center">
          <p class="mt-2">
            <strong>{{ file.title || file.originalName }}</strong><br/>
          </p>
        </div>
        <div v-else-if="isImage" class="document-display text-center">
          <p class="mt-2">
            <strong>{{ file.title || file.originalName }}</strong><br/>
          </p>
        </div>

        <!-- Processing Overlay (only when status === 1) -->
        <div v-if="file.status === 1" class="processing-overlay">
          <div class="spinner"></div>
          <div class="progress-text">در حال رمزنگاری برای عدم دانلود...</div>
        </div>
      </div>

      <!-- File Details Table -->
      <b-row>
        <b-col
            v-if="fullThumbnailUrl"
            cols="12" md="4" class="text-center">
          <div class="detail-thumb">
            <b-img
                v-if="fullThumbnailUrl"
                :src="fullThumbnailUrl"
                fluid
                class="rounded"
                alt="thumbnail"
            />
          </div>
        </b-col>
        <b-col cols="12" :md="fullThumbnailUrl ? 8 : 12">
          <b-table-simple bordered>
            <b-tr>
              <b-td style="width: 30%;">نام اصلی</b-td>
              <b-td>{{ file.originalName }}</b-td>
            </b-tr>
            <b-tr>
              <b-td>نوع</b-td>
              <b-td>{{ mediaTypeLabel }}</b-td>
            </b-tr>
            <b-tr>
              <b-td>حجم</b-td>
              <b-td>{{ file.size | fileSize }}</b-td>
            </b-tr>
            <b-tr>
              <b-td>وضعیت</b-td>
              <b-td>
                <span :style="{ color: statusColor }">{{ statusLabel }}</span>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>تاریخ آپلود</b-td>
              <b-td>{{ file.createdAt | dateTime }}</b-td>
            </b-tr>
            <b-tr v-if="file.alt">
              <b-td>Alt</b-td>
              <b-td>{{ file.alt }}</b-td>
            </b-tr>
            <b-tr v-if="file.tags">
              <b-td>برچسب‌ها</b-td>
              <b-td>{{ file.tags }}</b-td>
            </b-tr>
            <b-tr v-if="file.description">
              <b-td>توضیحات</b-td>
              <b-td>{{ file.description }}</b-td>
            </b-tr>
<!--            <b-tr v-if="file.streamUrl">-->
<!--              <b-td>آدرس HLS</b-td>-->
<!--              <b-td style="word-break: break-all; font-size: 0.8rem;">{{ fullStreamUrl }}</b-td>-->
<!--            </b-tr>-->
          </b-table-simple>
        </b-col>
      </b-row>

      <!-- Admin Security Controls -->
<!--      <div v-if="isAdmin && !disableActions" class="security-section mt-3 pt-3 border-top">-->
<!--        <h6 class="font-weight-bold mb-2">-->
<!--          <i class="fas fa-shield-alt text-primary"></i> مدیریت امنیت-->
<!--        </h6>-->
<!--        <b-row>-->
<!--          <b-col v-if="isVideo" cols="12" md="6" class="mb-2">-->
<!--            <b-button-->
<!--                :variant="file.isEncrypted ? 'danger' : 'outline-primary'"-->
<!--                block-->
<!--                @click="toggleEncryption"-->
<!--                :disabled="toggling"-->
<!--            >-->
<!--              <feather-icon :icon="file.isEncrypted ? 'UnlockIcon' : 'LockIcon'"></feather-icon>-->
<!--              {{ file.isEncrypted ? 'غیرفعال‌سازی رمز' : 'فعال‌سازی رمز' }}-->
<!--            </b-button>-->
<!--          </b-col>-->
<!--          <b-col cols="12" :md="isVideo ? 6 : 12" class="mb-2">-->
<!--            <b-button-->
<!--                :variant="file.isPublic ? 'success' : 'outline-secondary'"-->
<!--                block-->
<!--                @click="togglePublic"-->
<!--                :disabled="toggling"-->
<!--            >-->
<!--              <feather-icon :icon="file.isPublic ? 'EyeOffIcon' : 'GlobeIcon'"></feather-icon>-->
<!--              {{ file.isPublic ? 'غیرعمومی کردن' : 'عمومی کردن' }}-->
<!--            </b-button>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--      </div>-->

      <!-- Action Buttons -->
      <div class="mt-3 d-flex gap-2 flex-wrap">
        <b-button v-if="!disableActions" variant="primary" @click="$emit('edit')">
          <feather-icon icon="EditIcon"></feather-icon>
          ویرایش متادیتا
        </b-button>
        <b-button
            v-if="downloadUrl"
            variant="info"
            @click="downloadFile"
        >
          <feather-icon icon="DownloadIcon"></feather-icon>
          دانلود
        </b-button>
        <b-button
            v-if="isVideoOrAudio && !isHlsAvailable && !disableActions"
            variant="success"
            @click="$emit('hls')"
        >
          <feather-icon icon="FilmIcon"></feather-icon>
          تبدیل به HLS
        </b-button>
        <b-button v-if="!disableActions" variant="danger" @click="$emit('delete')">
          <feather-icon icon="DeleteIcon"></feather-icon>
          حذف
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {BAlert, BButton, BCol, BFormSelect, BImg, BModal, BRow, BTableSimple, BTd, BTr} from 'bootstrap-vue'
import Helper from '@/libs/Helper'
import {
  MediaLibraryGetPlaybackRequest,
  MediaLibraryToggleEncryptionRequest,
  MediaLibraryTogglePublicRequest
} from '@/libs/Api/MediaLibrary'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import axios from 'axios'
import Hls from "hls.js";

export default {
  name: 'FileDetailModal',
  components: {
    BModal,
    BRow,
    BCol,
    BImg,
    BTableSimple,
    BTr,
    BTd,
    BAlert,
    BButton,
    BFormSelect
  },
  props: {
    file: {type: Object, default: null},
    disableActions: {type: Boolean, default: false},
  },
  data() {
    return {
      hlsPlayer: null,
      hlsQualityLevels: [],
      selectedVariantQuality: -1,
      hlsPlaybackUrl: null,
      hlsToken: null,
      hlsKeyUrl: null,
      toggling: false,
      downloading: false,
      baseUrl: Helper.baseUrl,
      variantUrlMap: {}
    }
  },
  computed: {
    isVideo() {
      return this.file?.mediaType === 2
    },
    isAudio() {
      return this.file?.mediaType === 3
    },
    isVideoOrAudio() {
      return this.isVideo || this.isAudio
    },
    isImage() {
      return this.file?.mediaType === 1
    },
    isDocument() {
      return this.file?.mediaType === 4
    },
    mediaTypeLabel() {
      const map = { 1: 'تصویر', 2: 'ویدیو', 3: 'صوتی', 4: 'سند' }
      return map[this.file?.mediaType] || 'ناشناخته'
    },
    fileIcon() {
      const map = { 1: 'fa-image', 2: 'fa-video', 3: 'fa-music', 4: 'fa-file-alt' }
      return map[this.file?.mediaType] || 'fa-file'
    },
    documentIcon() {
      const map = {
        'pdf': 'fa-file-pdf',
        'doc': 'fa-file-word',
        'docx': 'fa-file-word',
        'xls': 'fa-file-excel',
        'xlsx': 'fa-file-excel',
        'ppt': 'fa-file-powerpoint',
        'pptx': 'fa-file-powerpoint',
        'txt': 'fa-file-alt',
        'zip': 'fa-file-archive'
      }
      const ext = this.file?.originalName?.split('.').pop()?.toLowerCase()
      return map[ext] || 'fa-file'
    },
    statusLabel() {
      const map = { 0: 'در انتظار', 1: 'در حال پردازش', 2: 'پردازش شده', 3: 'ناموفق' }
      return map[this.file?.status] || 'ناشناخته'
    },
    statusColor() {
      const map = { 0: '#f59e0b', 1: '#3b82f6', 2: '#22c55e', 3: '#ef4444' }
      return map[this.file?.status] || '#94a3b8'
    },
    isHlsAvailable() {
      return this.isVideoOrAudio && this.file?.streamUrl && this.file.streamUrl.endsWith('.m3u8')
    },
    isAdmin() {
      const user = this.$store?.getters?.['auth/user'] || {}
      return user?.isAdmin || user?.role === 'admin' || true
    },
    fullFileUrl() {
      if (!this.file?.fileUrl) return null
      const url = this.file.fileUrl
      if (url.startsWith('http://') || url.startsWith('https://')) return url
      const cleanUrl = url.startsWith('/') ? url.substring(1) : url
      return `${this.baseUrl}${cleanUrl}`
    },
    fullStreamUrl() {
      if (!this.file?.streamUrl) return null
      const url = this.file.streamUrl
      if (url.startsWith('http://') || url.startsWith('https://')) return url
      const cleanUrl = url.startsWith('/') ? url.substring(1) : url
      return `${this.baseUrl}${cleanUrl}`
    },
    fullThumbnailUrl() {
      if (!this.file?.thumbnailUrl) return null
      const url = this.file.thumbnailUrl
      if (url.startsWith('http://') || url.startsWith('https://')) return url
      const cleanUrl = url.startsWith('/') ? url.substring(1) : url
      return `${this.baseUrl}${cleanUrl}`
    },
    downloadUrl() {
      if (!this.file?.id) return null
      const base = this.baseUrl.endsWith('/') ? this.baseUrl : this.baseUrl + '/'
      return `${base}api/MediaLibrary/download/${this.file.id}`
    },
    variantQualities() {
      if (!this.file?.variants || !Array.isArray(this.file.variants)) return []
      const hlsVariants = this.file.variants.filter(v =>
          v.variantType && v.variantType.startsWith('HLS_') && v.variantType !== 'HLS_MASTER'
      )
      const result = []
      hlsVariants.forEach(v => {
        const quality = v.variantType.replace('HLS_', '')
        const path = v.path
        const fullUrl = path.startsWith('http') ? path : `${this.baseUrl}${path.startsWith('/') ? '' : '/'}${path}`
        result.push({ quality, url: fullUrl })
        this.variantUrlMap[quality] = fullUrl
      })
      result.sort((a, b) => {
        const aNum = parseInt(a.quality)
        const bNum = parseInt(b.quality)
        return aNum - bNum
      })
      return result
    },
    variantQualityOptions() {
      const options = [{ value: -1, text: 'خودکار (Auto)' }]
      this.variantQualities.forEach((v, index) => {
        options.push({ value: index, text: v.quality })
      })
      return options
    }
  },
  watch: {
    file: {
      immediate: true,
      handler(newFile) {
        if (newFile) {
          this.hlsPlaybackUrl = null
          this.hlsToken = null
          this.hlsKeyUrl = null
          this.destroyHlsPlayer()
          this.variantUrlMap = {}
          this.selectedVariantQuality = -1
        }
      }
    }
  },
  methods: {
    onModalShown() {
      if (this.isHlsAvailable) {
        this.fetchPlaybackUrlAndInit()
      }
    },
    async fetchPlaybackUrlAndInit() {

      this.hlsPlaybackUrl = this.fullStreamUrl
      this.initHlsPlayer()
      try {
        const request = new MediaLibraryGetPlaybackRequest(this)
        request.setParams(this.file.id)
        request.fetch(
            (content) => {
              if (content && content.playbackUrl) {
                this.hlsPlaybackUrl = content.playbackUrl
                this.hlsToken = content.token
                this.hlsKeyUrl = content.keyUrl
                this.initHlsPlayer()
              } else {
                this.hlsPlaybackUrl = this.fullStreamUrl
                this.initHlsPlayer()
              }
            },
            (error) => {
              console.warn('⚠️ Playback token fetch failed, using direct URL:', error)
              this.hlsPlaybackUrl = this.fullStreamUrl
              this.initHlsPlayer()
            }
        )
      } catch (error) {

        console.warn('⚠️ Playback token fetch error, using direct URL:', error)
        this.hlsPlaybackUrl = this.fullStreamUrl
        this.initHlsPlayer()
      }
    },
    initHlsPlayer(qualityVariant) {
      const media = this.$refs.hlsMedia
      if (!media) return

      let sourceUrl = this.hlsPlaybackUrl
      if (qualityVariant && this.variantUrlMap[qualityVariant]) {
        sourceUrl = this.variantUrlMap[qualityVariant]
      }
      if (!sourceUrl) return

      this.destroyHlsPlayer()

      if (typeof Hls !== 'undefined' && Hls.isSupported()) {
        const hls = new Hls({
          enableWorker: true,
          lowLatencyMode: true,
          xhrSetup: (xhr, url) => {
            if (url.includes('/api/encryption/key/')) {
              const authedUrl = this.hlsKeyUrl && url.split('?')[0] === this.hlsKeyUrl.split('?')[0]
                  ? this.hlsKeyUrl
                  : `${url}${url.includes('?') ? '&' : '?'}token=${this.hlsToken}`
              xhr.open('GET', authedUrl, true)
            }
          }
        })
        hls.loadSource(sourceUrl)
        hls.attachMedia(media)

        // Quality levels only relevant for video
        if (this.isVideo) {
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            this.hlsQualityLevels = hls.levels.map((level, index) => ({
              index,
              height: level.height,
              bitrate: level.bitrate
            }))
            if (qualityVariant) {
              hls.currentLevel = 0
            } else {
              this.selectedVariantQuality = -1
            }
          })
        } else {
          // Audio: just play
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            // For audio, we don't need quality selection
          })
        }

        hls.on(Hls.Events.ERROR, (event, data) => {
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                hls.startLoad()
                break
              case Hls.ErrorTypes.MEDIA_ERROR:
                hls.recoverMediaError()
                break
              default:
                hls.destroy()
                break
            }
          }
        })

        this.hlsPlayer = hls
        media.play().catch(() => {
        })
      } else if (media.canPlayType('application/vnd.apple.mpegurl')) {
        media.src = sourceUrl
        media.addEventListener('loadedmetadata', () => {
          media.play().catch(() => {
          })
        })
      } else {
        const wrapper = media.closest('.hls-player-wrapper')
        if (wrapper) {
          wrapper.innerHTML = `<div class="text-center p-3">مرورگر شما از پخش HLS پشتیبانی نمی‌کند.</div>`
        }
      }
    },
    destroyHlsPlayer() {
      if (this.hlsPlayer) {
        try {
          this.hlsPlayer.destroy()
        } catch (e) {
          console.warn('HLS destroy error:', e)
        }
        this.hlsPlayer = null
      }
      this.hlsQualityLevels = []
    },
    changeVariantQuality(qualityIndex) {
      if (qualityIndex === -1) {
        this.initHlsPlayer()
        this.selectedVariantQuality = -1
        return
      }
      const variant = this.variantQualities[qualityIndex]
      if (!variant) return
      this.initHlsPlayer(variant.quality)
    },
    async toggleEncryption() {
      const enable = !this.file.isEncrypted
      this.toggling = true
      try {
        const request = new MediaLibraryToggleEncryptionRequest(this)
        request.setParams({ fileId: this.file.id, enable })
        request.fetch(
            () => {
              this.toggling = false
              this.file.isEncrypted = enable
              this.$toast({
                component: ToastificationContent,
                position: 'bottom-center',
                props: {
                  title: 'موفق',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: `رمزنگاری ${enable ? 'فعال' : 'غیرفعال'} شد.`
                }
              })
              this.$bvModal.hide('modal-detail')
              this.$emit('updated')
            },
            (error) => {
              this.toggling = false
              this.showToast('error', 'خطا در تغییر رمزنگاری', error.message)
            }
        )
      } catch (error) {
        this.toggling = false
        this.showToast('error', 'خطا در تغییر رمزنگاری', error.message)
      }
    },
    async togglePublic() {
      const isPublic = !this.file.isPublic
      this.toggling = true
      try {
        const request = new MediaLibraryTogglePublicRequest(this)
        request.setParams({ fileId: this.file.id, isPublic })
        request.fetch(
            () => {
              this.toggling = false
              this.file.isPublic = isPublic
              this.$toast({
                component: ToastificationContent,
                position: 'bottom-center',
                props: {
                  title: 'موفق',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: `فایل ${isPublic ? 'عمومی' : 'غیرعمومی'} شد.`
                }
              })
              this.$bvModal.hide('modal-detail')
              this.$emit('updated')
            },
            (error) => {
              this.toggling = false
              this.showToast('error', 'خطا در تغییر وضعیت عمومی', error.message)
            }
        )
      } catch (error) {
        this.toggling = false
        this.showToast('error', 'خطا در تغییر وضعیت عمومی', error.message)
      }
    },
    async downloadFile() {
      if (!this.downloadUrl || this.downloading) return
      this.downloading = true
      console.log(this.downloadUrl)
      try {
        const token = localStorage.getItem('accessToken') || ''
        const response = await axios({
          url: this.downloadUrl,
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          responseType: 'blob'
        })
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = this.file.originalName || 'download'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
        this.downloading = false
      } catch (error) {
        this.downloading = false
        console.error('Download error:', error)
        this.showToast('error', 'خطا در دانلود', error.message || 'مشکل در دانلود فایل')
      }
    },
    showToast(variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-center',
        props: {
          title,
          icon: 'XIcon',
          variant,
          text
        }
      })
    }
  },
  filters: {
    fileSize(bytes) {
      if (!bytes) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    dateTime(iso) {
      if (!iso) return '—'
      const d = new Date(iso)
      return d.toLocaleDateString('fa-IR') + ' ' + d.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })
    }
  }
}
</script>

<style scoped>
.hls-player-wrapper {
  background: #0f172a;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
}

.hls-player-wrapper video,
.hls-player-wrapper audio {
  max-height: 400px;
  display: block;
  background: #000;
  width: 100%;
}

.hls-player-wrapper.audio-player {
  background: #1e293b;
  padding: 20px;
}

.hls-player-wrapper.audio-player audio {
  max-height: none;
  background: transparent;
}
.quality-control {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  border-radius: 8px;
  z-index: 10;
  font-size: 13px;
}
.quality-control select {
  padding: 4px 12px;
  border-radius: 6px;
  background: #1e293b;
  color: #fff;
  border: none;
  font-size: 13px;
  cursor: pointer;
  outline: none;
}
.detail-thumb {
  background: #f1f5f9;
  border-radius: 14px;
  padding: 1rem;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detail-thumb img {
  max-height: 200px;
  object-fit: contain;
}
.security-section {
  background: #f8fafc;
  padding: 12px 16px;
  border-radius: 12px;
}
.gap-2 {
  gap: 0.5rem;
}

.media-display {
  background: #f8fafc;
  border-radius: 12px;
  padding: 12px;
  position: relative;
  min-height: 80px;
}

.fallback-video-wrapper video,
.audio-display audio {
  border-radius: 8px;
}

/* Processing Overlay */
.processing-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  z-index: 20;
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.processing-overlay .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.processing-overlay .progress-text {
  font-size: 13px;
  opacity: 0.9;
}
</style>
